<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <div v-if="showUI" class="margin_top_40" style="margin: 20px">

      <div class="item-heading-desc-div">
        <weex-text class="item-heading">{{getNachInstructionsHeader}}</weex-text>
      </div>

      <weex-text class="item-bold-heading">{{followInstructions}}</weex-text>

      <div class="item-row-alignment margin-top-10" v-for="(instruction, index) in nachInstructions" :key="instruction+index">
        <weex-text class="nach-instruction-index">{{index+1}}.</weex-text>
        <weex-text class="nach-instruction-text" v-html="instruction"></weex-text>
      </div>

      <div v-if="showSignConsent" class="item-row-alignment margin_top_20">
        <weex-image
          :src="signCheckBoxLink"
          @click="onSignConsentClicked"
          class="sign-consent-checkbox"></weex-image>
        <weex-text class="sign-consent-text">{{bankSignMatchesWithPanSignConsent.consentValue}}
        </weex-text>
      </div>

      <file-attach-button
        class="button_horizontal_center margin_top_40"
        size="big"
        :enabled-text-style="attachFileButtonTextStyle"
        :enabled-btn-style="attachFileButtonStyle"
        file-attach-button-id="attachDocument"
        text="Attach Mandate Form"
        :attach-image-des-src="mandateImageDesSrc"
        @filesAttached="onNachFormAttached">
      </file-attach-button>

      <wxc-button
        text="Continue"
        class="horizontal_center margin-top-40 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="onContinue">
      </wxc-button>
    </div>
  </div>
</template>

<script>
import ToolBar from "@/components/layout/ToolBar";
import Loading from "@/components/layout/Loading";
import WxcButton from "@/../weex-ui/packages/wxc-button/index"
import ErrorAlertItem from "@/components/layout/ErrorAlertItem"
import { Constants } from "@/components/Constants";
import loanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import ActivityRedirectItem from "@/components/layout/ActivityRedirectItem";
import { Activities } from "@/utils/ActivityNavigator";
import DataSource from "@/data/DataSource";
import AlertService from "@/components/core/alert/AlertService";
import { MessageConstants } from "@/utils/MessageConstantUtil";
import FileAttachButton from "@/components/layout/FileAttachButton";
import LoanTasksActivityNavigator from "@/utils/LoanTasksActivityNavigator";
import { ImageResourcesUtil } from "@/utils/ImageResourcesUtil";
import AttributeUtil from "@/utils/AttributeUtil";
import StageCommentItem from "../layout/StageCommentItem";
import LoanTasksUtility from "../../utils/LoanTasksUtility";
import storageUtil from "../../utils/StorageUtil";

export default {
  name: "NachActivity",
  components: {
    ActivityRedirectItem,
    ToolBar,
    Loading,
    ErrorAlertItem,
    FileAttachButton,
    WxcButton,
    StageCommentItem
  },

  data: () => ({
    toolbarTitle: 'EMI Payment Registration',
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    filledNachForm: null,
    documentUploaded: false,
    showUI: false,
    file: null,
    downloadFile: false,
    nachInstructionsData: {},
    bankSignMatchesWithPanSignConsent: {
      "checked": false,
      "consentValue": "Do you know if your signature in Bank matches with PAN?"
    }
  }),

  methods: {
    showError(errorData) {
      this.loading = false;
      this.networkError = errorData;
      this.errorAlertEvent = true;
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    onSignConsentClicked() {
      this.bankSignMatchesWithPanSignConsent.checked = !this.bankSignMatchesWithPanSignConsent.checked
    },

    onNachFormAttached(e) {
      this.file = e.files[0];
      this.loading = true;
      DataSource.createDocument(
        Constants.LOANS,
        loanScopeDataHolder.getLoanId(),
        Constants.NACH.toUpperCase(),
        Constants.getDescription(Constants.NACH),
        Constants.NACH,
        this.file
      )
        .then(createDocumentRes => {
          this.loading = false;
          if (createDocumentRes.errorOccurred) {
            this.showError(createDocumentRes.data)
          } else {
            this.documentUploaded = true;
            this.showToast(MessageConstants.NACH_UPLOADED)
          }
        });
    },

    onContinue() {
      if (this.documentUploaded) {
        if (this.showSignConsent) {
          this.loading = true;
          DataSource.createOrUpdateAttribute(
            AttributeUtil.getAttributeUpdateDto(
              Constants.LOANS,
              loanScopeDataHolder.getLoanId(),
              AttributeUtil.getSingleAttributeData(
                "bank.signature.pan.match",
                "Bank Signature Pan Match",
                this.bankSignMatchesWithPanSignConsent.checked.toString()
              )
            )
          )
            .then(res => {
              if (res.errorOccurred) {
                this.showError(res.data)
              } else {
                this.getNextTask()
              }
            })
        } else {
          this.getNextTask();
        }
      } else {
        this.showToast(MessageConstants.UPLOAD_NACH_FORM);
      }
    },

    getNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    }
  },

  created() {
    this.loading = true;
    LoanTasksUtility.getLoanStageConfigData(loanScopeDataHolder.getLoanId(),
      loanScopeDataHolder.getCurrentLoanTask().name)
      .then(res => {
        this.loading = false;
        if (res.errorOccurred) {
          this.showError(res.data);
        } else {
          const properties = res.data.properties
          if (properties && properties['nach.instructions']) {
            this.nachInstructionsData = properties['nach.instructions']
          }
          this.showUI = true;
        }
      });
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    getNachInstructionsHeader() {
      return "The Mandate Registration form from the Bank/NBFC has to be signed. The signature has to match with the signature in banking system records to be accepted. Incorrect details could lead to penalty fee or the loan being rejected."
    },

    followInstructions() {
      return "To complete the process please follow the instructions below";
    },

    tasks() {
      return [Activities.NACH_FORM, Activities.NACH];
    },

    currentTaskName() {
      return loanScopeDataHolder.getCurrentLoanTask()
        ? loanScopeDataHolder.getCurrentLoanTask().name : "";
    },

    showSignConsent() {
      return this.nachInstructionsData['signatureConsent']
    },

    nachInstructions() {
      return this.nachInstructionsData['instructions'] ? this.nachInstructionsData['instructions']: []
    },

    signCheckBoxLink() {
      if (this.bankSignMatchesWithPanSignConsent.checked) {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CHECKED_CHECKBOX)
      } else {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.UNCHECKED_CHECKBOX)
      }
    },


    mandateImageDesSrc() {
      if (this.documentUploaded) {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN);
      } else {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
      }
    },

    attachFileButtonStyle() {
      return {
        'backgroundColor': '#ffffff',
        'border-width': '1px',
        'border-style': 'solid',
        'border-color': 'gray'
      }
    },

    attachFileButtonTextStyle() {
      return { 'text-align': 'center', 'color': '#000000' };
    },
  },
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>

.nach-instruction-index {
  font-size: 14px;
  color: black;
  margin-right: 3px;
}

.nach-instruction-text {
  font-size: 14px;
  color: black;
}

.sign-consent-checkbox {
  width: 24px;
  height: 24px;
}

.sign-consent-text {
  width: 100%;
  margin-left: 10px;
  color: black;
  font-size: 14px;
}
</style>
